import { Flex, Text } from '@radix-ui/themes';
import { Battery, BatteryCharging, BatteryLow, Cable, Lock, Wifi, WifiOff } from 'lucide-react';
import type { MacMetrics } from '@mac-remote/protocol';

/**
 * The always-visible summary: charge, and where the Mac's traffic is going. Two
 * facts, because they are the two that change what you would do next — a Mac at 8%
 * on battery is about to disappear, and a Mac routing through a VPN explains a
 * latency number that otherwise looks like a bug.
 *
 * Tapping opens the full panel.
 */
export function MacBadge({ metrics, onClick }: { metrics: MacMetrics | null; onClick: () => void }) {
  const battery = metrics?.battery;
  const primary = metrics?.net.find((n) => n.primary);

  const onAc = battery?.source === 'ac';
  const low = battery?.percent != null && battery.percent <= 20 && !onAc;

  const BatteryIcon = onAc ? BatteryCharging : low ? BatteryLow : Battery;
  const NetIcon = !primary ? WifiOff : primary.kind === 'wifi' ? Wifi : primary.kind === 'vpn' ? Lock : Cable;

  return (
    <button className="hbtn" onClick={onClick} title="Состояние мака">
      <BatteryIcon size={15} style={{ color: low ? 'var(--red-11)' : undefined }} />
      <Text size="1" style={{ color: low ? 'var(--red-11)' : 'var(--app-hint)' }}>
        {battery?.percent != null ? `${battery.percent}%` : '—'}
      </Text>
      <Flex align="center" style={{ opacity: primary ? 1 : 0.5 }}>
        <NetIcon size={15} />
      </Flex>
    </button>
  );
}
